import React from 'react';

import { CheckCircleOutline, ErrorOutline } from '@mui/icons-material';
import { Box, Container, Paper, Typography } from '@mui/material';

import plantsIllustration from './plants.svg';

type Props = {
  icon: 'ERROR' | 'SUCCESS' | 'PLANTS';
  title: string;
  description: string;
  action?: JsxNode;
};
export default function MessagePage({ icon, title, description, action }: Props) {
  const renderMessageIcon = () => {
    switch (icon) {
      case 'ERROR':
        return <ErrorOutline fontSize="large" sx={{ mb: 1, color: 'brand.red' }} />;
      case 'SUCCESS':
        return <CheckCircleOutline fontSize="large" sx={{ mb: 1, color: 'brand.green' }} />;
      case 'PLANTS':
        return <Box component="img" src={plantsIllustration} sx={{ mb: 2 }} />;
    }
  };

  return (
    <Container maxWidth="xs">
      <Paper>
        <Box p={4} textAlign="center">
          {renderMessageIcon()}
          <Box mb={4}>
            <Typography variant="h4" component="h1" gutterBottom>
              {title}
            </Typography>

            <Typography paragraph>{description}</Typography>
          </Box>
          {action}
        </Box>
      </Paper>
    </Container>
  );
}
